"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Componente primário de interação com o usuário
 */
var Button = function Button(_ref) {
  var children = _ref.children,
      color = _ref.color,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      onClick = _ref.onClick,
      startIcon = _ref.startIcon,
      variant = _ref.variant,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: color,
    disabled: disabled,
    fullWidth: fullWidth,
    onClick: onClick,
    size: "large",
    startIcon: startIcon || null,
    variant: variant,
    className: className
  }, children);
};

exports.Button = Button;
Button.propTypes = {
  /**
   * Texto do botão
   */
  children: _propTypes.default.string.isRequired,

  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,

  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,

  /**
   * Propriedade para deixar o botão com largura máxima
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Função que será executada quando o botão for clicado
   */
  onClick: _propTypes.default.func.isRequired,

  /**
   * Ícone que aparecerá antes do texto
   */
  startIcon: _propTypes.default.node,

  /**
   * Variante do botão
   */
  variant: _propTypes.default.oneOf(['contained', 'outlined']),

  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string
};
Button.defaultProps = {
  disabled: false,
  fullWidth: false,
  startIcon: null,
  variant: undefined,
  className: null
};
var _default = Button;
exports.default = _default;